import api from "../utils/api";
import { LOGOUT } from "./types";
import { send as sendAlert } from "./alert";

const fail = (error, fallback) => ({
  success: false,
  error: error?.response?.data?.error || error?.response?.data || { message: error?.message || fallback },
});

export const analyze = ({ file, dataStart }) => async (dispatch) => {
  try {
    const form = new FormData();
    form.append("file", file);
    form.append("dataStartRow", String(dataStart?.row || 1));
    form.append("dataStartColumn", String(dataStart?.column || 1));

    const res = await api.post("/staff/clocks/import/analyze", form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    if (error?.response?.status === 401) dispatch({ type: LOGOUT });
    const result = fail(error, "Unable to analyze the import file.");
    dispatch(sendAlert(result.error?.message || "Unable to analyze the import file.", "error"));
    return result;
  }
};

export const report = (payload) => async (dispatch) => {
  try {
    const res = await api.post("/staff/clocks/import/report", payload);
    return res.data;
  } catch (error) {
    if (error?.response?.status === 401) dispatch({ type: LOGOUT });
    const result = fail(error, "Unable to generate the import report.");
    dispatch(sendAlert(result.error?.message || "Unable to generate the import report.", "error"));
    return result;
  }
};

export const apply = (payload) => async (dispatch) => {
  try {
    const res = await api.post("/staff/clocks/import/apply", payload);
    if (res.data?.success) {
      dispatch(sendAlert("Time entries imported.", "success"));
    }
    return res.data;
  } catch (error) {
    if (error?.response?.status === 401) dispatch({ type: LOGOUT });
    const result = fail(error, "Unable to import time entries.");
    dispatch(sendAlert(result.error?.message || "Unable to import time entries.", "error"));
    return result;
  }
};
